import { useEffect, useState } from 'react'
import PrioritiesList from '../../../common/components/PrioritiesList'
import ProfileBase from '../../../components/Profile/ProfileBase'
import { useOnboardingStore } from '../../../store/onboarding-store'
import { authFetch } from '../../../common/utils/cognito'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next'

const ChangePriorities = () => {
  const navigate = useNavigate()
  const fetchSelectedTracks = useOnboardingStore(
    (state) => state.fetchSelectedTracks,
  )
  const { selectedTracks } = useOnboardingStore()
  const [selectedPriorities, setSelectedPriorities] =
    useState<number[]>(selectedTracks)

  useEffect(() => {
    fetchSelectedTracks()
  }, [fetchSelectedTracks])

  useEffect(() => {
    setSelectedPriorities(selectedTracks)
  }, [selectedTracks])

  const handleSaveClick = async () => {
    const response = await authFetch(`${process.env.REACT_APP_API_URL}/me`, {
      method: 'PATCH',
      body: JSON.stringify({
        trackIds: selectedPriorities,
      }),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    navigate('/profile')
  }

  return (
    <ProfileBase
      backButtonAction={() => navigate('/profile')}
      title={t('profile.changePriorities')}
      buttonTitle={t('profile.save')}
      onButtonClick={handleSaveClick}
    >
      <PrioritiesList
        selectedPriorities={selectedPriorities}
        setSelectedPriorities={setSelectedPriorities}
      />
    </ProfileBase>
  )
}

export default ChangePriorities
